import React, { useEffect, useState } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import SBInvoiceListPageActions from './selfBilledInvoices/components/SBInvoiceListPageActions';
import SBCreditNoteListPageActions from './selfBilledCreditNotes/components/SBCreditNoteListPageActions';
import SBDebitNoteListPageActions from './selfBilledDebitNotes/components/SBDebitNoteListPageActions';
import SBRefundListPageActions from './selfBilledRefunds/comopnents/SBRefundListPageActions';
import SBInvoiceListPage from './selfBilledInvoices/pages/SBInvoiceListPage';
import SBCreditNoteListPage from './selfBilledCreditNotes/pages/SBCreditNoteListPage';
import SBDebitNoteListPage from './selfBilledDebitNotes/pages/SBDebitNoteListPage';
import SBRefundListPage from './selfBilledRefunds/pages/SBRefundListPage';
import { useSelector } from 'react-redux';
import TopBar from '../components/TopBar';
import BulkUploadListPageActions from './bulkUpload/components/BulkUploadListPageActions';

const tabs = [
  { key: 'self-billed-invoices', label: 'Invoices' },
  { key: 'self-billed-credit-notes', label: 'Credit Notes' },
  { key: 'self-billed-debit-notes', label: 'Debit Notes' },
  { key: 'self-billed-refunds', label: 'Refunds' },
];

const getTopBarTitle = (tab) => {
  switch (tab) {
    case 'self-billed-invoices':
      return 'Invoice List';
    case 'self-billed-credit-notes':
      return 'Credit Note List';
    case 'self-billed-debit-notes':
      return 'Debit Note List';
    case 'self-billed-refunds':
      return 'Refund List';
    default:
      return 'Documents';
  }
};

const getTopBarActions = (tab, user) => {
  if (user?.permissions?.documents !== 2) return null;

  switch (tab) {
    case 'self-billed-invoices':
      return (
        <Stack direction="row" spacing={1}>
          <BulkUploadListPageActions />
          <SBInvoiceListPageActions />
        </Stack>
      );
    case 'self-billed-credit-notes':
      return (
        <Stack direction="row" spacing={1}>
          <BulkUploadListPageActions />
          <SBCreditNoteListPageActions
            actions={[
              {
                label: '+ Raise Self Billed Credit Note',
                action: 'create',
                target: '/self-billed-documents/credit-notes/create',
              },
            ]}
          />
        </Stack>
      );
    case 'self-billed-debit-notes':
      return (
        <Stack direction="row" spacing={1}>
          <BulkUploadListPageActions />
          <SBDebitNoteListPageActions
            actions={[
              {
                label: '+ Raise Self Billed Debit Note',
                action: 'create',
                target: '/self-billed-documents/debit-notes/create',
              },
            ]}
          />
        </Stack>
      );
    case 'self-billed-refunds':
      return (
        <Stack direction="row" spacing={1}>
          <BulkUploadListPageActions />
          <SBRefundListPageActions
            actions={[
              {
                label: '+ Raise Self Billed Refund',
                action: 'create',
                target: '/self-billed-documents/refunds/create',
              },
            ]}
          />
        </Stack>
      );
    default:
      return null;
  }
};

const DocumentListPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.org.org.user);
  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get('tab') || 'self-billed-invoices';
  const [selectedTab, setSelectedTab] = useState(initialTab);

  useEffect(() => {
    setSelectedTab(initialTab);
  }, [initialTab]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    navigate(`/self-billed-documents?tab=${newValue}`);
  };

  return (
    <Stack direction="column" spacing={3}>
      <TopBar title={getTopBarTitle(selectedTab)} />

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Tabs value={selectedTab} onChange={handleTabChange}>
          {tabs.map((tab) => (
            <Tab key={tab.key} label={tab.label} value={tab.key} />
          ))}
        </Tabs>
        {getTopBarActions(selectedTab, user)}
      </Box>
      <Box>
        {selectedTab === 'self-billed-invoices' && <SBInvoiceListPage />}
        {selectedTab === 'self-billed-credit-notes' && <SBCreditNoteListPage />}
        {selectedTab === 'self-billed-debit-notes' && <SBDebitNoteListPage />}
        {selectedTab === 'self-billed-refunds' && <SBRefundListPage />}
      </Box>
    </Stack>
  );
};

export default DocumentListPage;
